import { ReactNode } from 'react'
import clsx from 'clsx'

interface NoticeProps {
  icon: React.ReactElement
  title: string
  children: ReactNode
  className?: string
}

export const Notice = ({ icon, title, children, className }: NoticeProps) => {
  return (
    <div className={clsx('fly-notice', className)}>
      <div className="fly-notice-icon">{icon}</div>
      <div>
        <div className="fly-notice-title">{title}</div>
        <div className="fly-notice-text">{children}</div>
      </div>
    </div>
  )
}
